import { Asset } from "./assets.model";
import { Organization } from "./organization.model";
import { Employee } from "./employee.model";

export class CommentUser {
  id: number;
  employee: Employee;
  constructor() {
    this.id = 0;
    this.employee = new Employee();
  }
}

export class Comment {
  id: number;
  body: string;
  media: Asset[];
  organization: Organization;
  title: string;
  create_date: string;
  user: CommentUser;
  constructor() {
    this.id = 0;
    this.body = "";
    this.organization = new Organization();
    this.media = [];
    this.title = "";
    this.create_date = "";
    this.user = new CommentUser();
  }
}
